export const SECONDS = 1000;
export const MINUTES = SECONDS * 60;
